document.addEventListener("DOMContentLoaded", function(){
  let wrapper = document.querySelector('.blog-articles');
  let nextUrl = wrapper.dataset.nextUrl;
  let btn = document.querySelector('.loadmore_button .button');
  let spinner = document.querySelector('.load-more_spinner ');
 
  async function loadMoreArticles(){
    if(!nextUrl) return;
    btn.style.display = "none";
    spinner.style.display = "inline-block";
 
    let response = await fetch(nextUrl);
    let text = await response.text();
    let doc = new DOMParser().parseFromString(text, 'text/html');
    let newArticles = doc.querySelector('.blog-articles');
    let newUrl = newArticles.dataset.nextUrl || null;
 
    wrapper.insertAdjacentHTML('beforeend', newArticles.innerHTML);
 
    nextUrl = newUrl;
    spinner.style.display = "none";
 
    if(nextUrl){
      btn.style.display = "inline-block";
    } else {
      btn.remove();
    }
  }
 
  if(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      loadMoreArticles();
    });
  }

  const inputs = document.querySelectorAll('.blog-search-input');
  if (!inputs.length) return;

  inputs.forEach(input => {
    const container = input.closest('.blog-section') || document;
    const items = container.querySelectorAll('.blog-item');
    const noResults = container.querySelectorAll('.no-results-message');

    input.addEventListener('input', () => {
      const query = input.value.toLowerCase().trim();
      let visibleCount = 0;

      items.forEach(item => {
        const title = (item.dataset.title || item.textContent || '').toLowerCase();
        if (!query) {
          item.classList.add("hidden");
        } else if (title.includes(query)) {
          item.classList.remove("hidden");
          visibleCount++;
        } else {
          item.classList.add("hidden");
        }
      });

      noResults.forEach(msg => {
        msg.classList.toggle('hidden', !(query && visibleCount === 0));
      });
    });
  });

});